import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "page_loader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", {
      class: "loader",
      id: "page_loader_spinner"
    }, [
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div")
    ], -1)
  ]))]))
}